import { Outlet, ScrollRestoration } from "react-router-dom";
import MarketingNav from "./MarketingNav";
import MarketingFooter from "./MarketingFooter";
import { useMarketingAnalytics } from "./hooks/useMarketingAnalytics";

export default function MarketingLayout() {
  useMarketingAnalytics();
  return (
    <div className="min-h-screen bg-[#FAF7F2] text-[#1A2A3A] antialiased" data-testid="marketing-layout">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:bg-white focus:px-4 focus:py-2 focus:rounded-full focus:shadow"
      >
        Skip to content
      </a>
      <MarketingNav />
      <main id="main">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
